export const EMAIL_PREVIEW_BASE_STYLES = `
    :root {
      font-size: 14px;
    }
    body {
      margin: 0;
      padding: 12px;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5;
      color: #111;
      background: #fff;
    }
    .ql-snow {
      box-sizing: border-box;
      width: 100%;
    }
    .ql-editor {
      box-sizing: border-box;
      line-height: 1.42;
      outline: none;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: inherit;
      font-family: inherit;
    }
    .ql-editor > * {
      cursor: text;
    }
    .ql-editor p,
    .ql-editor ol,
    .ql-editor ul,
    .ql-editor pre,
    .ql-editor blockquote,
    .ql-editor h1,
    .ql-editor h2,
    .ql-editor h3,
    .ql-editor h4,
    .ql-editor h5,
    .ql-editor h6 {
      margin: 0;
      padding: 0;
    }
    .ql-editor ol,
    .ql-editor ul {
      padding-left: 1.5em;
      list-style-position: outside;
    }
    .ql-editor ol > li,
    .ql-editor ul > li {
      list-style-type: inherit;
      margin: 0.25em 0;
    }
    .ql-editor blockquote {
      border-left: 4px solid #ccc;
      margin: 5px 0;
      padding-left: 16px;
      color: #555;
    }
    .ql-editor pre {
      background-color: #f0f0f0;
      border-radius: 4px;
      margin: 5px 0;
      padding: 12px;
      font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
      white-space: pre-wrap;
    }
    .ql-editor code {
      background-color: #f0f0f0;
      border-radius: 3px;
      font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
      padding: 2px 4px;
    }
    .ql-editor a {
      color: #0d6efd;
      text-decoration: underline;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
    .ql-align-justify {
      text-align: justify;
    }
    .ql-direction-rtl {
      direction: rtl;
      text-align: inherit;
    }
    .ql-indent-1 {
      margin-left: 1.5em;
    }
    .ql-indent-2 {
      margin-left: 3em;
    }
    .ql-indent-3 {
      margin-left: 4.5em;
    }
    .ql-indent-4 {
      margin-left: 6em;
    }
    .ql-indent-5 {
      margin-left: 7.5em;
    }
    .ql-indent-6 {
      margin-left: 9em;
    }
    .ql-indent-7 {
      margin-left: 10.5em;
    }
    .ql-indent-8 {
      margin-left: 12em;
    }
    .ql-font-serif {
      font-family: "Georgia", "Times New Roman", Times, serif;
    }
    .ql-font-monospace {
      font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    }
    .ql-size-small {
      font-size: 0.85em;
    }
    .ql-size-large {
      font-size: 1.5em;
    }
    .ql-size-huge {
      font-size: 2em;
    }
  `;
